module.exports = __webpack_public_path__ + "static/img/dialog_header_bg.2bda56de.png";